export type GrantDiscoverFacets = {
  agency?: string[];
  state?: string[];
  catalog_scope?: string[];
};

export const GRANT_DISCOVER_SORT_OPTIONS = [
  { value: "relevance", label: "Relevance" },
  { value: "program_number", label: "Program # (A–Z)" },
  { value: "program_number_desc", label: "Program # (Z–A)" },
  { value: "name", label: "Name (A–Z)" },
  { value: "name_desc", label: "Name (Z–A)" },
] as const;

export function buildGrantDiscoverSearchUrl(params: {
  query?: string;
  keyword?: string;
  agency?: string;
  catalogScope?: string;
  state?: string;
  sort?: string;
  page?: number;
  municipalityId?: number;
  excludeFormula?: boolean;
}): string {
  const search = new URLSearchParams();
  if (params.query) search.set("query", params.query);
  if (params.keyword) search.set("keyword", params.keyword);
  if (params.agency) search.set("agency", params.agency);
  if (params.catalogScope) search.set("catalog_scope", params.catalogScope);
  if (params.state) search.set("state", params.state);
  if (params.excludeFormula) search.set("exclude_formula", "true");
  if (params.sort && params.sort !== "relevance") search.set("sort", params.sort);
  if (params.page && params.page > 1) search.set("page", String(params.page));
  if (params.municipalityId) search.set("municipality_id", String(params.municipalityId));
  const qs = search.toString();
  return `/grants.json${qs ? `?${qs}` : ""}`;
}
